import { render, staticRenderFns } from "./ProductCategorySecondMenu.vue?vue&type=template&id=17a9780a&scoped=true&"
import script from "./ProductCategorySecondMenu.vue?vue&type=script&lang=js&"
export * from "./ProductCategorySecondMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategorySecondMenu.vue?vue&type=style&index=0&id=17a9780a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a9780a",
  null
  
)

export default component.exports